var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.rm
    ? _c("div", [
        _vm._m(0),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "container" },
          [
            _c(
              "h1",
              {
                staticStyle: {
                  "font-size": "2em",
                  "font-weight": "300",
                  color: "#33475b",
                  margin: "0",
                },
              },
              [
                _vm._v("Edit "),
                _c("span", { staticStyle: { "text-transform": "lowercase" } }, [
                  _vm._v(_vm._s(_vm.rm.AlternativeLabel)),
                ]),
              ]
            ),
            _vm._v(" "),
            _c("hr", {
              staticStyle: { "border-color": "#bbb", margin: "20px 0 30px" },
            }),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "alert alert-warning", attrs: { role: "alert" } },
              [
                _vm._v(
                  "\n            Please remember to press Save Changes before refreshing this page and when the questionnaire is complete!\n        "
                ),
              ]
            ),
            _vm._v(" "),
            _c("AlternativeEditor", {
              attrs: {
                propRm: _vm.rm.AlternativeEditor,
                propErrors: _vm.errors,
                propFormId: "editAlternativePageAlternativeForm",
              },
              on: { "form-submit": _vm.save },
            }),
          ],
          1
        ),
      ])
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c(
      "nav",
      {
        staticClass: "navbar navbar-expand-sm navbar-light bg-light fixed-top",
      },
      [
        _c("div", { staticClass: "container justify-content-end" }, [
          _c(
            "button",
            {
              staticClass: "btn btn-lg btn-success",
              attrs: {
                type: "submit",
                form: "editAlternativePageAlternativeForm",
              },
            },
            [_vm._v("Save Changes")]
          ),
        ]),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }